module.exports = __webpack_public_path__ + "img/coeurvert_on.cafbe40c.gif";